import Sticky from 'sticky-js'

class Tabs {
  sticky = null
  constructor () {
    this.init()
  }

  init () {
    const $onglets = $('.onglets')
    const $blockTabs = $('.wp-block-tabs')

    this.sticky = new Sticky('.onglets', {
      marginTop: 150,
      stickyClass: 'onglets-sticky'
    })

    if ($onglets.length) {
      const $ongletsItem = $onglets.find('.onglets-item')
      const $ongletsMobileItem = $onglets.find('.onglets-mobile-item')
      const $wpBlockTabsWrapper = $('<div class="wp-block-tabs-wrapper relative"></div>')

      $onglets.insertBefore('.wp-block-tabs:first')
      $wpBlockTabsWrapper.insertAfter($onglets)
      $wpBlockTabsWrapper.append($blockTabs)

      $ongletsItem.each((index, element) => {
        const $element = $(element)
        if ($element.hasClass('active')) {
          $('.wp-block-tabs.' + $element.data('slug')).addClass('active')
        }
        $element.click((event) => {
          const $onglet = $(event.currentTarget)
          this.showOnglet($onglet.data('slug'))
        })
      })

      $ongletsMobileItem.click(event => {
        const $onglet = $(event.currentTarget)
        if ($onglet.hasClass('active')) {
          this.openOngletMobile()
        } else {
          this.showOnglet($onglet.data('slug'))
          this.closeOngletMobile()
        }
      })

      $(document).on('click', (event) => {
        if (!($ongletsMobileItem.is(event.target) || $ongletsMobileItem.has(event.target).length > 0)) {
          this.closeOngletMobile()
        }
      })
    }
  }

  openOngletMobile () {
    const $ongletMobileList = $('.onglets-mobile-list')
    $ongletMobileList.addClass('open')
  }

  closeOngletMobile () {
    const $ongletMobileList = $('.onglets-mobile-list')
    $ongletMobileList.removeClass('open')
  }

  showOnglet (slug) {
    const $onglets = $('.onglets')
    const $ongletsItem = $onglets.find('.onglets-item')
    const $ongletsMobileItem = $onglets.find('.onglets-mobile-item')
    const $onglet = $('.onglets-list .onglets-item.' + slug)
    const $ongletMobile = $('.onglets-mobile-list .onglets-mobile-item.' + slug)

    $ongletsItem.removeClass('active')
    $ongletsMobileItem.removeClass('active')
    $onglets.find('li.active').removeClass('active')
    $onglet.closest('li').addClass('active')
    $onglet.addClass('active')
    $ongletMobile.closest('li').addClass('active')
    $ongletMobile.addClass('active')

    $('.wp-block-tabs.active').removeClass('active').fadeOut(300)
    $('.wp-block-tabs.' + slug).fadeIn(300, function () {
      $(this).addClass('active')
    })

    // $('html, body').animate({
    //   scrollTop: $('.inner-container').offset().top
    // }, 1000)

    const targetOffset = $('.wp-block-tabs-wrapper').offset().top - 150

    $('html, body').animate({
      scrollTop: targetOffset
    }, 1000)
  }
}

export default Tabs
